var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJscript(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.562,
    height: 110.589,
    id: "javascript",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6a329",
    d: "M78.562 21.671H0l7.365 79.867 31.912 9.051 31.912-9.051Z",
    "data-name": "Path 275"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bf22",
    d: "M39.277 28.178v75.643l25.856-7.325 6.29-68.318Z",
    "data-name": "Path 276"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.847 37.976H20.092l-2.769 29.9.057-.186h33.774l-1.1 12.651-10.776 3.1-10.935-3.15-.655-7.657h-9.926l1.416 15.3 20.1 5.706 20.109-5.706 2.769-30.032H26.312l.46-10.006h24.869l.372 5.733h10.01Z",
    "data-name": "Path 277"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M39.286 37.976H20.092l-2.769 29.9.057-.186h21.905v-9.754H27.71l.46-10.006h11.116ZM27.71 72.639h-9.949l1.416 15.292 20.1 5.7V83.455l-10.935-3.158Z",
    "data-name": "Path 278"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M31.638 9.891h-6.994v5.021h12V0h-5ZM53.915.08H41.723V5.3c1.628 1.628 2.477 2.411 4.875 4.769h-4.875v4.76h12.191v-4.752l-4.87-4.769h4.875Z",
    "data-name": "Path 279"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJscript);
export default __webpack_public_path__ + "static/media/jscript.30ffc1ab15a9fddc7e224d81fafd1f9d.svg";
export { ForwardRef as ReactComponent };